module.exports = __webpack_public_path__ + "media/src/assets/Images/Bath-ee7d1f79957048ca1873895eb5f7e01e.svg";